var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeInspiration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 52,
    viewBox: "0 0 56 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_784_139)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 30,
    r: 12,
    fill: "#00B977"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6836 28H7L13 30H15.5L11.6836 28Z",
    fill: "#19122C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3164 28H48L42 30H39.5L43.3164 28Z",
    fill: "#19122C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8351 1.96507C26.7734 0.761576 29.2266 0.761576 31.1649 1.96507L36.5 5.27757L42.0363 8.24163C44.0477 9.31853 45.2743 11.443 45.2012 13.7234L45 20L45.2012 26.2766C45.2743 28.557 44.0477 30.6815 42.0363 31.7584L36.5 34.7224L31.1649 38.0349C29.2266 39.2384 26.7734 39.2384 24.8351 38.0349L19.5 34.7224L13.9637 31.7584C11.9523 30.6815 10.7257 28.557 10.7988 26.2766L11 20L10.7988 13.7234C10.7257 11.443 11.9523 9.31853 13.9637 8.24164L19.5 5.27757L24.8351 1.96507Z",
    fill: "url(#paint0_linear_784_139)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M24.9668 3.17773C26.8244 2.02439 29.1756 2.02439 31.0332 3.17773L35.9434 6.22656L35.957 6.23438L41.0518 8.96191C42.9794 9.99394 44.155 12.0304 44.085 14.2158L43.9004 19.9922L43.8994 20L43.9004 20.0078L44.085 25.7842C44.155 27.9695 42.9794 30.0061 41.0518 31.0381L35.957 33.7656L35.9434 33.7734L31.0332 36.8223C29.1756 37.9756 26.8244 37.9756 24.9668 36.8223L20.0566 33.7734L20.043 33.7656L14.9482 31.0381C13.0206 30.0061 11.845 27.9696 11.915 25.7842L12.0996 20.0078L12.1006 20L12.0996 19.9922L11.915 14.2158C11.845 12.0304 13.0206 9.99394 14.9482 8.96191L20.043 6.23438L20.0566 6.22656L24.9668 3.17773Z",
    fill: "url(#paint1_linear_784_139)",
    stroke: "white",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13H48L46 20.5L48 28H7L9 20.5L7 13Z",
    fill: "#00B977"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13H48L46 20.5L48 28H7L9 20.5L7 13Z",
    fill: "url(#paint2_linear_784_139)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M46.6611 14.25L44.7607 20.4268L44.7383 20.5L44.7607 20.5732L46.6611 26.75H8.33887L10.2393 20.5732L10.2617 20.5L10.2393 20.4268L8.33887 14.25H46.6611Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.722 22V19.2H14.366V22H13.722ZM15.2695 22V19.2H15.9455L17.1735 20.908V19.2H17.8175V22H17.1735L15.9135 20.244V22H15.2695ZM19.6833 22.048C19.5473 22.048 19.4166 22.0307 19.2913 21.996C19.1686 21.9587 19.0566 21.9093 18.9553 21.848C18.8566 21.784 18.7753 21.7133 18.7113 21.636C18.6473 21.556 18.6073 21.4707 18.5913 21.38L19.2273 21.2C19.2566 21.2773 19.3073 21.3453 19.3793 21.404C19.4539 21.46 19.5473 21.4893 19.6593 21.492C19.7686 21.4947 19.8593 21.4693 19.9313 21.416C20.0059 21.3627 20.0433 21.2933 20.0433 21.208C20.0433 21.1413 20.0166 21.0827 19.9633 21.032C19.9126 20.9813 19.8393 20.9427 19.7433 20.916L19.3473 20.816C19.2086 20.7813 19.0873 20.7267 18.9833 20.652C18.8819 20.5773 18.8019 20.4867 18.7433 20.38C18.6873 20.2707 18.6593 20.1467 18.6593 20.008C18.6593 19.7387 18.7486 19.5293 18.9273 19.38C19.1059 19.228 19.3579 19.152 19.6833 19.152C19.8619 19.152 20.0179 19.1773 20.1513 19.228C20.2846 19.276 20.3979 19.348 20.4913 19.444C20.5873 19.54 20.6633 19.66 20.7193 19.804L20.0873 19.992C20.0659 19.92 20.0193 19.8547 19.9473 19.796C19.8779 19.7373 19.7873 19.708 19.6753 19.708C19.5633 19.708 19.4753 19.7333 19.4113 19.784C19.3499 19.8347 19.3193 19.908 19.3193 20.004C19.3193 20.0707 19.3446 20.1267 19.3953 20.172C19.4459 20.2147 19.5153 20.2467 19.6033 20.268L19.9993 20.368C20.2259 20.424 20.4019 20.5293 20.5273 20.684C20.6553 20.836 20.7193 21.0093 20.7193 21.204C20.7193 21.38 20.6779 21.5307 20.5953 21.656C20.5153 21.7813 20.3979 21.8787 20.2433 21.948C20.0886 22.0147 19.9019 22.048 19.6833 22.048ZM21.4934 22V19.2H22.5934C22.7961 19.2 22.9761 19.2413 23.1334 19.324C23.2907 19.404 23.4134 19.516 23.5014 19.66C23.5921 19.8013 23.6374 19.9667 23.6374 20.156C23.6374 20.34 23.5934 20.5053 23.5054 20.652C23.4201 20.796 23.3001 20.9093 23.1454 20.992C22.9907 21.0747 22.8134 21.116 22.6134 21.116H22.1374V22H21.4934ZM22.1374 20.524H22.5974C22.7121 20.524 22.8041 20.4907 22.8734 20.424C22.9427 20.3547 22.9774 20.2653 22.9774 20.156C22.9774 20.0467 22.9401 19.9587 22.8654 19.892C22.7934 19.8227 22.6974 19.788 22.5774 19.788H22.1374V20.524ZM24.3104 22V19.2H24.9544V22H24.3104ZM25.8579 22V19.2H26.9579C27.1606 19.2 27.3406 19.24 27.4979 19.32C27.6553 19.3973 27.7779 19.5067 27.8659 19.648C27.9566 19.7867 28.0019 19.9467 28.0019 20.128C28.0019 20.3093 27.9566 20.4707 27.8659 20.612C27.7753 20.7533 27.6499 20.864 27.4899 20.944C27.3326 21.0213 27.1513 21.06 26.9459 21.06H26.5019V22H25.8579ZM27.3779 22L26.7459 20.888L27.2299 20.532L28.1139 22H27.3779ZM26.5019 20.468H26.9379C27.0126 20.468 27.0793 20.4533 27.1379 20.424C27.1966 20.3947 27.2419 20.3547 27.2739 20.304C27.3086 20.2507 27.3259 20.192 27.3259 20.128C27.3259 20.0293 27.2886 19.948 27.2139 19.884C27.1419 19.82 27.0459 19.788 26.9259 19.788H26.5019V20.468ZM30.8104 22L29.7624 19.2H30.4024L31.4904 22H30.8104ZM28.6264 22L29.7144 19.2H30.3544L29.3064 22H28.6264ZM29.1384 21.468V20.9H30.9824V21.468H29.1384ZM32.5063 22V19.792H31.6903V19.2H33.9623V19.792H33.1463V22H32.5063ZM34.6528 22V19.2H35.2968V22H34.6528ZM37.5203 22.048C37.2323 22.048 36.9776 21.9867 36.7563 21.864C36.5349 21.7387 36.3616 21.568 36.2363 21.352C36.1109 21.1333 36.0483 20.884 36.0483 20.604C36.0483 20.3213 36.1109 20.072 36.2363 19.856C36.3616 19.6373 36.5336 19.4667 36.7523 19.344C36.9736 19.2187 37.2269 19.156 37.5123 19.156C37.7976 19.156 38.0496 19.2187 38.2683 19.344C38.4896 19.4667 38.6629 19.6373 38.7883 19.856C38.9136 20.072 38.9763 20.3213 38.9763 20.604C38.9763 20.884 38.9136 21.1333 38.7883 21.352C38.6656 21.568 38.4949 21.7387 38.2763 21.864C38.0576 21.9867 37.8056 22.048 37.5203 22.048ZM37.5203 21.456C37.6776 21.456 37.8163 21.42 37.9363 21.348C38.0563 21.276 38.1496 21.176 38.2163 21.048C38.2829 20.9173 38.3163 20.7693 38.3163 20.604C38.3163 20.436 38.2816 20.288 38.2123 20.16C38.1429 20.0293 38.0483 19.928 37.9283 19.856C37.8083 19.7813 37.6696 19.744 37.5123 19.744C37.3549 19.744 37.2163 19.7813 37.0963 19.856C36.9763 19.928 36.8816 20.0293 36.8123 20.16C36.7429 20.288 36.7083 20.436 36.7083 20.604C36.7083 20.7693 36.7429 20.9173 36.8123 21.048C36.8816 21.176 36.9776 21.276 37.1003 21.348C37.2229 21.42 37.3629 21.456 37.5203 21.456ZM39.7282 22V19.2H40.4042L41.6322 20.908V19.2H42.2762V22H41.6322L40.3722 20.244V22H39.7282Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_784_139",
    x: 0,
    y: 2,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_784_139"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_784_139",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EE27B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4315"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_784_139",
    x1: 18.5,
    y1: 7.17,
    x2: 32.7055,
    y2: 35.7144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#083F14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499302,
    stopColor: "#179733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083F14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_784_139",
    x1: 17.25,
    y1: 15.4355,
    x2: 19.7275,
    y2: 29.0426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#083F14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499302,
    stopColor: "#179733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083F14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeInspiration);
export default __webpack_public_path__ + "static/media/badge-inspiration.e65a6439bcbe04ab192ca4a35f9d6b4c.svg";
export { ForwardRef as ReactComponent };